import ko from 'knockout';

ko.observable.fn.toggle = function () {
    if (typeof this() !== 'boolean') return;
    this(!this());
};
